import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FeaturedResources from '../components/VariantL/FeaturedResources';
import Intro from '../components/Intro';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '25px 0',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      padding: 0,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  container: {
    [theme.breakpoints.up('1140')]: {
      width: 1140,
      padding: 0,
    },
    width: '100%',
    padding: '24px 5%',
  },
}));

function VariantL() {
  const classes = useStyles();

  return (
    <div className={classes.root} data-test-id="hero-variant-l">
      <Grid
        container
        className={classes.container}
        direction="row"
        spacing={4}
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12} sm={4}>
          <Intro />
        </Grid>
        <Grid item xs={12} sm="auto">
          <FeaturedResources />
        </Grid>
      </Grid>
    </div>
  );
}

export default VariantL;
